import axios from "axios";
import availableDocumentTypes from "../actions/types/availableDocument.action.type";
import store from "../store/index";
import { saveAs } from "file-saver";
import { processResponse } from "./serviceUtil";
import {
  getErrorMessageFromException,
  API_BASE_URL,
  getExceptionMessage,
  getFileNameToDownload,
  listProps
} from "../utils/helper";
import { FI } from "../constants/sharedConstants.js";
import services from "./index.js";
import { ACTION_TYPES } from "./serviceLevelMonitoring.service.js";

export const availableDocumentService = {
  getAvailableDocument,
  downloadDocuments,
  getAvailableReports,
  getReportNames,
  downloadReports,
  getReportsList,
};

function downloadDocuments(billerFilesDto, fileFormat, requestStartTime, props) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;
    const loginUser = store.getState()?.loginUserReducer?.user;
    const PAGE_NAME = "downloadDocment";
    const roleId = loginUser?.role?.role_id;
    const data = {
      ...billerFilesDto,
      fileFormat,
    };
    axios
      .post(
        API_BASE_URL() + "/available-documents/download",
        {
          ...billerFilesDto,
          downloaded_file_format: fileFormat,
          download_by: loginUser.userId,
          role_type: loginUser?.role?.role_type,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        if (fileFormat) {
          var blob = new Blob([res.data]);
          const fileName = getFileNameToDownload(PAGE_NAME, roleId, data);

          saveAs(blob, fileName);

          if (billerFilesDto?.file_type === "Bill Payment") {
            const requestEndTime = new Date(
              performance.timeOrigin + performance.now()
            ).toISOString();

            services.serviceLevelMonitoringService
              .recordData({
                actionType: ACTION_TYPES.DOWNLOAD_DOCUMENT,
                fiNumber: loginUser?.fiNumber,
                loggedInUserId: loginUser.userId,
                requestStartTime,
                requestEndTime,
                requestParams: JSON.stringify(billerFilesDto),
              })
          }

          dispatch( { data: "Successfully download document",
                      type: availableDocumentTypes.AVAILABLE_DOCUMENT_DOWNLOAD_SUCCESS } );
          if (props?.searchBillerFilesDto && props?.setInitialLoading) {
            props?.setInitialLoading(true);
            dispatch(
              getAvailableDocument(props?.searchBillerFilesDto, props?.setInitialLoading)
            );
          }
        }
      })
      .catch(async (error) => {
        let errorObject = await extractErrorObject(error);
        const errMessage = getExceptionMessage(error, errorObject);
        props?.setShowApiExceptionMessage(true);
        dispatch( { error: errMessage,
                    type: availableDocumentTypes.AVAILABLE_DOCUMENT_DOWNLOAD_ERROR } );
      });
  };
}

// returns an object that has properties: .error, .timestamp.
// Argument 'error' may come as a regular Map or as a blob
const extractErrorObject = async (error) => {
  // regular case: error is sent in a Map (ResponseEntity<Map<String, Object>>)
  if (typeof error.response.data.text !== "function")
    return error?.response?.data;

  // here error comes from inside a Blob object (ResponseEntity<Object>)
  if (error.response.data.type === "application/json") // should always be the case; I don't know when it isn't
    return JSON.parse(await error.response.data.text());

  return { error: error.toJSON()?.message };
};

function downloadReports(reportDocData, props) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;
    const roleId = store.getState()?.loginUserReducer?.user?.role?.role_id;
    const PAGE_NAME = "report";

    axios
      .post(
        API_BASE_URL() + "/available-reports/download",
        { ...reportDocData },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        var blob = new Blob([res.data]);
        const fileName = getFileNameToDownload(
          PAGE_NAME,
          roleId,
          reportDocData
        );

        saveAs(blob, fileName);
        dispatch( { data: "Successfully download document",
                    type: availableDocumentTypes.AVAILABLE_REPORTS_DOWNLOAD_SUCCESS } );
      })
      .catch(async (error) => {
        let errorObject = await extractErrorObject(error);
        const errMessage = getExceptionMessage(error, errorObject);
        props?.setShowApiExceptionMessage(true);
        dispatch( { error: errMessage,
                    type: availableDocumentTypes.AVAILABLE_REPORTS_DOWNLOAD_ERROR } );
      });
  };
}

function getAvailableDocument(
  searchBillerFilesDto,
  setLoading,
  setBtnLoading
) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;
    const loginUser = store.getState()?.loginUserReducer?.user;
    const selectedFi = store.getState()?.fiReducer?.selectedFi;

    let request = {
      ...searchBillerFilesDto,
      biller_id:
        searchBillerFilesDto.biller_id !== undefined
          ? searchBillerFilesDto.biller_id
          : loginUser?.searchBillerFilesDto?.biller_id,
      fi_number: searchBillerFilesDto.ctb_id ? FI.CTB_BILLER  : selectedFi || loginUser?.fiNumber,
      role_type: loginUser?.role.role_type,
      portal_type: localStorage.getItem("type"),
      creditor_fi_number: loginUser.fi?.creditor_fi_number
    };
    if (loginUser.fiNumber == FI.CTB_BILLER && loginUser.billerCrossReferenceDto)
      request.ctb_id = loginUser.billerCrossReferenceDto.centralizedBillerId;

    axios
      .post(
        API_BASE_URL() + "/available-documents/list",
        request,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        dispatch( {data: res.data,  type: availableDocumentTypes.GET_AVAILABLE_DOCUMENT_SUCCESS} );
        processResponse(true, {setLoading, setBtnLoading});
      })
      .catch((error) => {
        const errorMessage = getExceptionMessage(error);
        dispatch( {error: errorMessage,  type: availableDocumentTypes.GET_AVAILABLE_DOCUMENT_ERROR} );
        processResponse(false, {setLoading, setBtnLoading}, errorMessage);
      });
  };
}

function getReportNames(searchBillerFilesDto) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;
    const loginUser = store.getState()?.loginUserReducer?.user;
    const selectedFi = store.getState()?.fiReducer?.selectedFi;
    axios
      .post(
        API_BASE_URL() + "/available-reports/reportNames",
        {
          ...searchBillerFilesDto,
          biller_id:    /// MB: in the BackEnd, class FiReportRequestDto does not have billerId field !!  [2025-09-15]
            searchBillerFilesDto.biller_id !== undefined
              ? searchBillerFilesDto.biller_id
              : loginUser?.searchBillerFilesDto?.biller_id,
          fiNumber: selectedFi || loginUser?.fiNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        dispatch( { data: res.data,
                    type: availableDocumentTypes.GET_REPORTS_NAME_SUCCESS } );
      })
      .catch((error) => {
        const errorResponse = getErrorMessageFromException(error) || error;
        dispatch( { error: errorResponse,
                    type: availableDocumentTypes.GET_REPORTS_NAME_ERROR } );
      });
  };
}

function getAvailableReports(searchBillerFilesDto, setLoading) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;
    const loginUser = store.getState()?.loginUserReducer?.user;
    const selectedFi = store.getState()?.fiReducer?.selectedFi;

    let request = {
      ...searchBillerFilesDto,
      biller_id:
        searchBillerFilesDto.biller_id !== undefined
          ? searchBillerFilesDto.biller_id
          : loginUser?.searchBillerFilesDto?.biller_id,
      fiNumber:
        loginUser?.searchBillerFilesDto?.fi_number ||
        selectedFi ||
        loginUser?.fiNumber,
      portalType: localStorage.getItem("type")
    };

    axios
      .post(
        API_BASE_URL() + "/available-reports/list",
        request,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        if (setLoading) {
          setLoading(false);
        }
        dispatch( { data: res.data,
                    type: availableDocumentTypes.GET_AVAILABLE_REPORTS_SUCCESS } );
      })
      .catch((error) => {
        if (setLoading) {
          setLoading(false);
        }
        const errorResponse = getErrorMessageFromException(error) || error;
        dispatch( { error: errorResponse,
                    type: availableDocumentTypes.GET_AVAILABLE_REPORTS_ERROR } );
      });
  };
}

function getReportsList(searchBillerFilesDto) {
  return (dispatch) => {
    const loginUser = store.getState()?.loginUserReducer?.user;
    const selectedFi = store.getState()?.fiReducer?.selectedFi;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        API_BASE_URL() + "/available-documents/report/list",
        {
          ...searchBillerFilesDto,
          biller_id:
            searchBillerFilesDto.biller_id !== undefined
              ? searchBillerFilesDto.biller_id
              : loginUser?.searchBillerFilesDto?.biller_id,
          fi_number: selectedFi || loginUser?.fiNumber,
          portal_type: localStorage.getItem("type")
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        dispatch( { data: res.data,
                    type: availableDocumentTypes.GET_AVAILABLE_REPORTS_LIST_SUCCESS } );
      })
      .catch((error) => {
        const errorResponse = getErrorMessageFromException(error) || error;
        dispatch( { error: errorResponse,
                    type: availableDocumentTypes.GET_AVAILABLE_REPORTS_LIST_ERROR } );
      });
  };
}
